import scene from '../../pages/NewBoxPage/assets/theme-previews/alpine-day.jpg';
import './gameCard.css';

export const gameCard = { left: scene, right: scene };
